import React, { PropsWithChildren, MouseEvent } from "react";

import { clsx } from "clsx";

type Props = {
  commonBtn?: boolean;
  secondary?: boolean;
  className?: string;
  id?: string;
  label?: string;
  icon?: string;
  type?: "button" | "submit" | "reset";
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onDoubleClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  onMouseEnter?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseOver?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseLeave?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  forwardedRef?: React.Ref<HTMLButtonElement>;
  active?: boolean;
  inline?: boolean;
  asLink?: boolean;
  border?: boolean;
  withIcon?: boolean;
  alignCenter?: boolean;
  alignRight?: boolean;
  buttonSpacing?: string;
  centered?: boolean;
  fullWidth?: boolean;
  rounded?: boolean;
  blurred?: boolean;
  disabled?: boolean;
  ml?: string;
  mr?: string;
  mt?: string;
  mb?: string;
  px?: string;
  py?: string;
  title?: string;
};

const Button = ({
  commonBtn,
  secondary,
  className,
  id,
  label,
  icon,
  type,
  onClick,
  onDoubleClick,
  active,
  inline,
  asLink,
  withIcon,
  centered,
  fullWidth,
  rounded,
  blurred,
  disabled,
  children,
  forwardedRef,
  title,
  ml,
  mr,
  mt,
  mb,
  px,
  py,
}: PropsWithChildren<Props>) => (
  <button
    className={clsx({
      [`${className ? className : ""}`]: className,
      "common-btn": commonBtn,
      secondary: secondary,
      "svg-icon": withIcon,
      [`${icon ? "icon-" + icon : ""}`]: icon,
      inline,
      ta_center: centered,
      "full-width": fullWidth,
      disabled,
      active,
      rounded,
      blurred,
      [`${asLink ? "as-link" : ""}`]: asLink,
      [`${ml ? "ml-" + ml : ""}`]: ml,
      [`${mr ? "mr-" + mr : ""}`]: mr,
      [`${mt ? "mt-" + mt : ""}`]: mt,
      [`${mb ? "mb-" + mb : ""}`]: mb,
      [`${px ? "px-" + px : ""}`]: px,
      [`${py ? "py-" + py : ""}`]: py,
    })}
    id={id}
    onClick={onClick}
    onDoubleClick={onDoubleClick}
    disabled={disabled}
    type={type}
    ref={forwardedRef}
    title={title}
  >
    {label && label}
    {children && children}
  </button>
);

export default Button;
